<div class="l-main" role="main">
	<div class="l-container">

		<div class="l-content">


			<div class="panel-pane bg-transparent align-center">
				<ul class="list--pipe">
					<li><a href="">Visit the UC Davis directory</a></li>
				</ul>
			</div>

			<div class="panel-pane box">
      
          
<!-- ********** Main content ********** -->
						<div id="main_section" role="main">

							<!-- Center column (primary content) -->

							<div id="center_column">

								<div id="center_column_inner_wrap">


   <div class="container">
   <div class="row">
   
   <div *ngIf="departments?.length >= 100">
   		<p class="alert">
			<em>Search returned more than 100 results. </em> Please refine your search if you would like more specific results.
		</p>
   </div>

   <table class="table">
   
   <thead class="thead-inverse">
   
   <tr>
   
   </tr>
   
   </thead>
   <tbody>
   

   <div *ngIf="departments?.length >0 && departments?.length <= 100">
   		Search returned {{departments?.length}} results
   </div>

   
   <ng-container *ngFor="let department of departments; let i=index">   
     
   <ng-container *ngIf="department.site==='UC DAVIS'">
   
   
   <ng-container *ngIf="i===0;">
     	<tr valign="top" style="background-color: #BCC5CF">
			<th style="width: 75%" colspan="4" align="left">UC Davis locations</th>
			<th style="width: 15%" align="left">Number</th>
		</tr>
   </ng-container>


   <tr *ngIf="department.singleDeptCrossRefOID !==null  ">
		<td style="width: 75%" colspan="4" align="left">
           <a routerLink="/deptDetailSearch/{{department.singleDeptCrossRefOID}}">
           {{department.directoryName}}</a>
        </td>
		<td style="width: 15%" align="left">{{department.phoneNumber}}</td>
   </tr>   
   
   

   <ng-container *ngIf="department.type === 'url'; then caseA; else caseB">
   </ng-container>

   <ng-template #caseA>
   <tr *ngIf="department.singleDeptCrossRefOID ===null  ">
   
        <td style="width: 75%" colspan="4" align="left">
         
           <a href="http://{{department.directoryName}}">
	 
           <ng-container *ngIf="department.headerDeptListingName === department.directoryName">
             {{department.directoryName}}
           </ng-container>	
           <ng-container *ngIf="department.headerDeptListingName !== department.directoryName">
             {{department.headerDeptListingName}}:&nbsp;{{department.directoryName}}
           </ng-container>	
          
           </a>

        </td>
	
	 	<td style="width: 15%" align="left">{{department.phoneNumber}}</td>

   </tr>
   </ng-template>

   <ng-template #caseB>
   <tr *ngIf="department.singleDeptCrossRefOID ===null  ">
   
        <td style="width: 75%" colspan="4" align="left">
         
           <a routerLink="/deptDetailSearch/{{department.headerDeptListingOID}}">
	 
           <ng-container *ngIf="department.headerDeptListingName === department.directoryName">
             {{department.directoryName}}
           </ng-container>	
           <ng-container *ngIf="department.headerDeptListingName !== department.directoryName">
             {{department.headerDeptListingName}}:&nbsp;{{department.directoryName}}
           </ng-container>	
          
           </a>

        </td>
	
	 	<td style="width: 15%" align="left">{{department.phoneNumber}}</td>

   </tr>
   </ng-template>

    
   </ng-container> <!-- ng-container *ngIf="department.site==='UC DAVIS'" -->
   
   </ng-container> <!--ng-container *ngFor="let department of departments; let i=index" -->
   


   <ng-container *ngIf="health">
     	<tr valign="top" style="background-color: #BCC5CF">
			<th style="width: 75%" colspan="4" align="left">UC Davis Health System locations</th>
			<th style="width: 15%" align="left">Number</th>
		</tr>
   </ng-container>

   
   <ng-container *ngFor="let department of departments; index as i;">
   
   <ng-container *ngIf="department.site==='UCDHS'">
   
     
   <tr *ngIf="department.singleDeptCrossRefOID !==null  ">
        <td style="width: 75%" colspan="4" align="left">
           <a routerLink="/deptDetailSearch/{{department.singleDeptCrossRefOID}}">
           {{department.directoryName}}</a>
        </td>
	 	<td style="width: 15%" align="left">{{department.phoneNumber}}</td>
   </tr>   
   
   
   <ng-container *ngIf="department.type === 'url'; then caseA; else caseB">
   </ng-container>

   <ng-template #caseA>
   <tr *ngIf="department.singleDeptCrossRefOID ===null  ">
   
        <td style="width: 75%" colspan="4" align="left">
         
           <a href="http://{{department.directoryName}}">
	 
           <ng-container *ngIf="department.headerDeptListingName === department.directoryName">
             {{department.directoryName}}
           </ng-container>	
           <ng-container *ngIf="department.headerDeptListingName !== department.directoryName">
             {{department.headerDeptListingName}}:&nbsp;{{department.directoryName}}
           </ng-container>	
          
           </a>

        </td>
	
	 	<td style="width: 15%" align="left">{{department.phoneNumber}}</td>

   </tr>
   </ng-template>

   <ng-template #caseB>
   <tr *ngIf="department.singleDeptCrossRefOID ===null  ">
   
        <td style="width: 75%" colspan="4" align="left">
         
           <a routerLink="/deptDetailSearch/{{department.headerDeptListingOID}}">
	 
           <ng-container *ngIf="department.headerDeptListingName === department.directoryName">
             {{department.directoryName}}
           </ng-container>	
           <ng-container *ngIf="department.headerDeptListingName !== department.directoryName">
             {{department.headerDeptListingName}}:&nbsp;{{department.directoryName}}
           </ng-container>	
          
           </a>

        </td>
	
	 	<td style="width: 15%" align="left">{{department.phoneNumber}}</td>

   </tr>
   </ng-template>

 
   </ng-container> <!-- ng-container *ngIf="department.site==='UCDHS'" -->
   
   </ng-container> <!-- ng-container *ngFor="let department of departments; index as i;" -->




   </tbody>
   </table>
   </div>
   </div>
   
   						</div>

						<!-- ********** End main content ********** -->
													</div>

							<!-- End center column -->

						</div>
				
				</div>		
		<!--end .l-content-->
		
		
	</div>

</div>
</div>
<!--End role=main-->

<p class="privacy">
	<strong>Privacy Notice:</strong> This campus directory is the property
	of <a href="https://www.ucdavis.edu"><font size="3" color="navy">University
			of California, Davis.</font> </a> To protect the privacy of individuals listed
	herein, in accordance with the State of California Information
	Practices Act, this directory may not be used, rented, distributed, or
	sold for commercial purposes.
</p>